import React, { useEffect } from 'react';
import { Sidebar, Menu, MenuItem, useProSidebar } from 'react-pro-sidebar';
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Header from "../Common/header";
import { MyDiv, PTag } from "../Common/Components";
import { AiFillDashboard } from "react-icons/ai";
import { BiMenu } from "react-icons/bi";
import { Button } from "react-bootstrap";

function TemplateAudit() {
    const [, setModule] = React.useState([{
        Masters: '',
    }
    ])

    const navigate = useNavigate();
    const { collapseSidebar } = useProSidebar();
    const pathname = useLocation().pathname;

    useEffect(() => {
        async function init() {
            const data = await localStorage.getItem('role');

            setModule(JSON.parse(data));
        }
        init();
        if ((localStorage.getItem("token") === null) && (localStorage.getItem(" ") === null)) {
            navigate("/login");
        }
    }, [navigate]);


    return (
        <div>
            <Header />
            <MyDiv className="GeneralContainer">
                <MyDiv className="LeftSideContainer">
                    <Button className="Sidebarcollapse" onClick={() => collapseSidebar()}>
                        <BiMenu />
                    </Button>
                    <Sidebar>
                        <Menu>
                            <MenuItem Tooltip title="Dashboard" className={`${pathname === 'audit/dashboard' ? "menuActive" : ""}`} icon={<AiFillDashboard />} component={<Link to="audit/dashboard" />}>Dashboard</MenuItem>
                          
                        </Menu>
                    </Sidebar>
              

                </MyDiv>
                <MyDiv className="RightMainContainer">
                    <MyDiv className="Right-Side-Main-Container">
                        <Outlet />
                    </MyDiv>
                    <MyDiv className="footer-copyrights ">
                        <PTag className="text-center mt-15">{(new Date().getFullYear())} @ SNS. All rights reserved</PTag>
                    </MyDiv>
                </MyDiv>

            </MyDiv>
        </div>
    );
}

export default TemplateAudit;